module.exports = __webpack_public_path__ + "img/safewater-login.ec753730.png";